/** @see DesignModule.id of the root module of the @see Design. */
export const rootModuleId = 'rootModule';
